import page from "router/page";
import _ from "lodash";

import Report from "report/report";
import ActivityProcessor from "utils/activity-processor"; 
import DateRangeExtractor from "utils/date-range-extractor";
import Formatter from "utils/formatter";

import groupNames from "lookups/group-name";

const activityProcessor   = new ActivityProcessor();
const dateRangeExtractor  = new DateRangeExtractor();
const formatter           = new Formatter();

/**
 * Handle the display of activity/project report
 */
class ProjectActivityReport extends Report {

    name  = 'project';
    title = 'Activities by Project';

    /**
     * Define the routes being handle by activity/project
     */
    registerRoutes() {
        let app = this.app;

        page('/activity/project', (context) => {
            this.setReport(context);
            this.assemble();
        });
    
        page('/activity/project/:projectId/:from/:to', async (context) => {
    
            let projectId = context.params.projectId;
            let dateFrom = context.params.from;
            let dateTo   = context.params.to;
    
            this.setReport(context);

            console.log(`Generating report for project ${projectId} – Report Task by Project`);
            await this.generateReportTaskByProject(dateFrom, dateTo, projectId);

            this.assemble();
            app.findComponent('DateRangePicker').setDate(dateFrom, dateTo);
        });
    }

    /**
     * Do post UI handling after loading the data
     */
    assemble() {
        let app             = this.app;
        let projectSelector = app.findComponent('ProjectSelector');
        let timeline        = app.findComponent('TimelineBreakdown');

        let project         = app.get('active.project');
        let dates           = app.get('dateMarkings.dates');

        projectSelector.apply();

        if (project) { projectSelector.o.setValue(project.ProjectID); }

        if (!app.hasRecords()) { return; }

        timeline.refit(dates);
    }

    /**
     * Build the report's data layer
     * 
     * @param {string} dateFrom   - Date range start
     * @param {string} dateTo     - Date range end
     * @param {int}    projectId  - Project ID
     */
    async generateReportTaskByProject(dateFrom, dateTo, projectId) {
        let app                 = this.app;
        let projects            = app.get(`projects.lookup`);
        let users               = app.get('resources.lookup');

        let response            = await this.apiCaller.report.getTaskByProject(dateFrom, dateTo, projectId);
    
        app.set('active.project', projects[projectId]);

        app.reportIsLoaded();
        app.hasRecords(response);
    
        if (!app.hasRecords()) { return; }
    
        let report              = activityProcessor.processActivitiesOfProject(response, dateFrom, dateTo);
    
        let workDays            = dateRangeExtractor.getWeekdays(dateFrom, dateTo);
        let dateMarkings        = dateRangeExtractor.addMarkings(workDays);
    
        let totalTimeSpent      = report.timeSpent.hours;
        let groupDistribution   = [];
        
        _.each(report.aggregatedSummary, (groupTimeSpent, groupName) => {
    
            let groupLabel = groupNames[groupName];
    
            groupDistribution.push({
                group        : groupName,
                label        : groupLabel,
                timeSpent    : groupTimeSpent.timeSpent,
                distribution : formatter.toPercentage(groupTimeSpent.timeSpent.hours / totalTimeSpent)
            });
        });
    
        groupDistribution = _.orderBy(groupDistribution, 'timeSpent.seconds', 'desc');
    
        _.each(report.resources, (resource, bindname) => {
            resource.resource = users[`@${bindname}`];
            resource.label = groupNames[resource.group];
        });
    
        report.resources  = _.orderBy(report.resources, 'timeSpent.seconds', 'desc');
    
        
        
        app.set('distribution', groupDistribution);
    
        app.set('overall.timeSpent', report.timeSpent.hours);
    
        app.set('resourceWorkedOn', report.resources);
        app.set('plottedActivities', report.plottedActivities);
    
        app.set('dateMarkings', dateMarkings);
        app.findComponent('DateRangePicker').setDate(dateFrom, dateTo);
    }
}

module.exports = ProjectActivityReport;
